export default "__VITE_ASSET__CyUfzjaW__"